import { getMinValueFromArray, getMaxValueFromArray } from ".";

export default function isNumberInRange(number, range) {  
  // Assuming range is an array with two elements [min, max]
  const min = getMinValueFromArray(range);
  const max = getMaxValueFromArray(range);

  return number >= min && number <= max;
}
